import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { COLUMNS } from './columns'
import Glyph from 'component/utils/Glyph'
import Row from 'component/utils/Row'
import FilterForm from './FilterForm'
import Modal from './Modal'
import iconDownload from 'images/icon-download.svg'
import moment from 'moment'

class TableQueryLog extends Component {
  state = {
    clicked: false,
    renderModal: false,
    log: null,
    maxLength: 150,
  }

  getTxt = (log) => {
    const { translate, functionality } = this.props
    const functionalityValue = functionality || (log && log.functionality)
    const functionalityKey = typeof functionalityValue === 'string' && functionalityValue
      ? (functionalityValue.startsWith('query.logs.') ? functionalityValue : `query.logs.${functionalityValue}`)
      : null
    const functionalityLabel = functionalityKey ? translate(functionalityKey) : '-'
    const element = document.createElement('a')

    const file = new Blob(
      [
        `\n${translate('query.logs.modal.functionality')}\n`,
        functionalityLabel,
        '\n\n',
        translate('query.logs.modal.date'),
        '\n',
        moment(log.date).format('l'),
        '\n\n',
        translate('query.logs.modal.hour'),
        '\n',
        moment(log.date).format('LT'),
        '\n\n',
        translate('queryLogs.table.column.endpoint'),
        '\n',
        log.endpoint,
        '\n\n',
        translate('query.logs.modal.request'),
        '\n',
        log.request,
        '\n\n',
        translate('query.logs.modal.response'),
        '\n',
        log.response,
      ],
      { type: 'text/plain' }
    )

    element.href = URL.createObjectURL(file)
    element.download = 'logs.txt'
    // Required for this to work in FireFox
    document.body.appendChild(element)
    element.click()
    element.parentElement.removeChild(element)
  }

  renderModal = () => {
    const { translate, functionality } = this.props
    const { renderModal, log } = this.state

    if (!renderModal) {
      return
    }

    return (
      <Modal
        translate={translate}
        closeModal={() =>
          this.setState({
            renderModal: false,
            log: null,
          })
        }
        log={log}
        getTxt={() => this.getTxt(log)}
        functionality={functionality}
      />
    )
  }

  renderColumn = (key, data, classNameCol) => (
    <td className={classNameCol || 'td-log'} key={key}>
      {data}
    </td>
  )

  renderLabelContent = (value) => value && value.length > this.state.maxLength
      ? `${value.substring(0, this.state.maxLength)}...`
      : value

  renderLabelDate = (value) =>
    `${moment(value).format('l')} ${moment(value).format('LT')}`

  renderRow = (row, i) => (
    <tr key={i} className={i % 2 && 'query-logTable-nth-child'}>
      {this.renderColumn('date', this.renderLabelDate(row.date), 'log-8')}
      {this.renderColumn('request', this.renderLabelContent(row.request))}
      {this.renderColumn('response', this.renderLabelContent(row.response))}
      {this.renderColumn(
        'details',
        <span
          onClick={() => this.setState({ renderModal: true, log: row })}
          className='table-icon'
        >
          <Glyph type='eye' color='primary' />
        </span>,
        'log-8'
      )}

      {this.renderColumn(
        'download',
        <a
          href='#'
          className='table-icon-iconDownload'
          onClick={() => this.getTxt(row)}
        >
          <img src={iconDownload} />
        </a>,
        'log-8'
      )}
    </tr>
  )

  renderHeader = (column) => {
    const { translate } = this.props
    return (
      <th className='th-log' key={column.label}>
        <div className={`cell small-column ${column.className}`}>
          <div className='th-log'>
            {translate(`queryLogs.table.column.${column.label}`)}
          </div>
        </div>
      </th>
    )
  }

  submit = (value) => this.props.submit(value)

  renderForm = () => {
    const { clicked } = this.state
    const { translate, filters, user } = this.props
    if (clicked) {
      return (
        <div className='log-filter'>
          <FilterForm
            translate={translate}
            filters={filters}
            submit={this.submit}
            title={translate('queryLogs.table.title')}
            classFilter='log-filter-form-clicked'
            user={user}
            classTitle
          />
        </div>
      )
    }
  }

  clickFilter = () => {
    const { clicked } = this.state
    this.setState({ clicked: !clicked })
  }

  renderTable = () => {
    const { list, translate } = this.props
    if (list.length) {
      return (
        <table className='table bordered query-logTable'>
          <thead>
            <tr className='thead-log'>{COLUMNS.map(this.renderHeader)}</tr>
          </thead>
          <tbody>{list && list.map(this.renderRow)}</tbody>
        </table>
      )
    }
    return (
      <div style={{ width: '98%', margin: '2rem auto' }}>
        <div className='notification notification-warning'>
          {translate('query.logs.result.empty')}
        </div>
      </div>
    )
  }

  render() {
    const { clicked } = this.state
    const { translate } = this.props
    return (
      <div className='log-table'>
        {this.renderForm()}
        <div
          className={clicked ? 'query-log-table-clicked' : 'query-log-table'}
        >
          <Row className='query-log'>
            <span className='button-log' onClick={this.clickFilter}>
              <i
                className={`glyph glyph-grey icon glyph-${
                  clicked ? 'double-arrow-left' : 'double-arrow-right'
                }`}
              />
              <span className='query-log-label'>
                {translate('queryLogs.table.title')}
              </span>
            </span>
          </Row>
          {this.renderTable()}
        </div>
        {this.renderModal()}
      </div>
    )
  }
}

export default TableQueryLog

TableQueryLog.propTypes = {
  translate: PropTypes.func,
  list: PropTypes.array,
  submit: PropTypes.func,
  functionality: PropTypes.string,
  count: PropTypes.number,
  current: PropTypes.number,
  handlePagination: PropTypes.func,
  pages: PropTypes.number,
  filters: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
}
